// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__JDYd-","logo":"Footer_logo__zn9nT","navigation":"Footer_navigation__vjlpO"};